import { render, staticRenderFns } from "./changeroute.vue?vue&type=template&id=5594bf18"
import script from "./changeroute.vue?vue&type=script&lang=js"
export * from "./changeroute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports